import React from 'react';
import PropTypes from 'prop-types';
import { Panel, PageHeader } from 'react-bootstrap';

QuestionnaireCompleted.propTypes = {
  redirectUrl: PropTypes.string.isRequired
};

export function QuestionnaireCompleted({
  redirectUrl, countDown
}) {

  return (
    <div>
      <PageHeader>Questionnaire Completed</PageHeader>
      <Panel >
        <p>Thank you for completing the questionnaire.</p>

        <p>
          You will be automatically redirected back to the broker portal in {countDown/1000} seconds
        </p>

        <p>Alternatively, if you are not redirected, please click <a href={redirectUrl}>here</a> to continue</p>
      </Panel>
    </div>
  )
}




// WEBPACK FOOTER //
// ./src/components/questionnaireCompleted/QuestionnaireCompleted.js